import { USERS_API } from "../../constants/api";
import axios from "../fetch/fetch";

export const getAllUsersAPI = async (): Promise<any[]> => {
    const response = await axios.get(USERS_API);
    return response.data;
};
